<template>
  <v-dialog v-model="dialogVisible" class="white" max-width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="ma-0 pa-0" icon x-small v-bind="attrs" v-on="on">
        <v-icon>mdi-help-circle</v-icon>
      </v-btn>
    </template>
    <v-card class="ma-0 white angle-input-dialog">
      <v-card-title>
        Hilfe Winkeleingabe
      </v-card-title>
      <v-card-text>
        <p>
          Links/Rechts wird über das Vorzeichen gesteuert:<br />
          Werte &lt; 0 = LINKS<br />
          Werte &gt; 0 = RECHTS
        </p>
        <h4 v-if="angle">Aktueller Wert:</h4>
        <p v-if="angle">{{ angle }}° {{ direction }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="onOkClick">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogAngleInputHelp',
  components: {},
  props: ['angle'],
  data: () => ({
    dialogVisible: false,
  }),
  computed: {
    direction() {
      return this.angle < 0 ? 'LINKS' : 'RECHTS';
    },
  },
  methods: {
    onOkClick() {
      var value = this.outputAngle;
      this.dialogVisible = false;
      if (this.updateTimeout) clearTimeout(this.updateTimeout);
      this.$emit('angleChanged', value);
    },
  },
};
</script>

<style scoped>
.angle-input-dialog {
  overflow-x: hidden;
}

.sensor-input-button {
  position: absolute;
  right: 20px;
}
</style>
